export default "__VITE_ASSET__B25Y_Ubi__"